/** 검색 호출 skip 기준과 드롭다운 노출 조건이 공유하는 최소 키워드 길이 */
export const MIN_KEYWORD_LENGTH = 2;

/** 미달이면 '아직 검색 안 함' — 결과 0건과 구분해야 함 */
export const isKeywordSearchable = (keyword: string) =>
  keyword.trim().length >= MIN_KEYWORD_LENGTH;
